import Navigation from '../components/site/Navigation';
import Hero from '../components/site/Hero';
import TrustBar from '../components/site/TrustBar';
import Intro from '../components/site/Intro';
import SystemsComparison from '../components/site/SystemsComparison';
import Pricing from '../components/site/Pricing';
import Process from '../components/site/Process';
import WhyPrep from '../components/site/WhyPrep';
import Team from '../components/site/Team';
import Reviews from '../components/site/Reviews';
import FAQ from '../components/site/FAQ';
import BrandBridge from '../components/site/BrandBridge';
import SocialFollow from '../components/site/SocialFollow';
import Footer from '../components/site/Footer';
import FloatingCTA from '../components/site/FloatingCTA';

export default function LashLiftLanding() {
  return (
    <main data-testid="landing-page" className="bg-brand-bg text-brand-cream">
      <Navigation />
      <Hero />
      <TrustBar />
      <Intro />
      <SystemsComparison />
      <Team />
      <Pricing />
      <Process />
      <WhyPrep />
      <Reviews />
      <FAQ />
      <BrandBridge />
      <SocialFollow />
      <Footer />
      <FloatingCTA />
    </main>
  );
}
